const UserReg = () => import('@pages/main/user/Info')

export const reg = [
  {
    path: '/user/reg',
    name: 'UserReg',
    component: UserReg,
    meta: {auth: false}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/reg.route.js